/** The six connection slots of the Multi Internet card, in display order (ids are the design's). */
export const MI_CONNECTIONS = [
  { id: 'fibra', mbps: 500, on: true },
  { id: 'wifi', mbps: 300, on: true },
  { id: 'g5', mbps: 150, on: false },
  { id: 'cabo', mbps: 250, on: false },
  { id: 'isp2', mbps: 200, on: false },
  { id: 'g4', mbps: 60, on: false },
] as const;

export type MiConnectionId = (typeof MI_CONNECTIONS)[number]['id'];

export const MI_TOTAL = MI_CONNECTIONS.length;
